/**
 * The page query uses the same names as queryPhotos.
 * Slideshow options: Seconds, Tags, Countdown, Forward, Reverse.
 * Keep the names and true/false words aligned with functions/photoQuery.js.
 */
import { emptyFacetState, FACET_ROW_META } from './tagConfigUtils';

const FACET_FIELDS = {
  person: 'people',
  people: 'people',
  place: 'places',
  places: 'places',
  pet: 'pets',
  pets: 'pets',
  general: 'general',
  event: 'events',
  events: 'events',
  holiday: 'holidays',
  holidays: 'holidays',
  camera: 'cameras',
  cameras: 'cameras',
};

function parseBool(value) {
  const text = String(value || '').trim().toLowerCase();
  if (text === '1' || text === 'true' || text === 'yes' || text === 'on') return true;
  if (text === '0' || text === 'false' || text === 'no' || text === 'off') return false;
  return null;
}

export function parseGalleryLocation(search) {
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
  const filters = emptyFacetState();
  const display = { seconds: null, tags: true, countdown: false, forward: true, reverse: true };
  let untagged = false;
  let hasFacet = false;
  let hasDisplay = false;
  let deviceId = '';

  for (const [rawKey, rawValue] of params.entries()) {
    const key = String(rawKey || '').trim().toLowerCase();
    const value = String(rawValue || '').trim();
    if (!key || key === 'photo' || key === 'limit' || key === 'offset') continue;
    if (key === 'deviceid') {
      deviceId = value.toLowerCase();
      continue;
    }
    if (key === 'seconds') {
      hasDisplay = true;
      const seconds = Number(value);
      if (Number.isInteger(seconds) && seconds >= 1 && seconds <= 3600) display.seconds = seconds;
      continue;
    }
    if (key === 'tags' || key === 'countdown' || key === 'forward' || key === 'reverse') {
      hasDisplay = true;
      const bit = parseBool(value);
      if (bit != null) display[key] = bit;
      continue;
    }
    if (key === 'untagged') {
      const bit = parseBool(value);
      untagged = bit === true;
      continue;
    }
    const field = FACET_FIELDS[key];
    if (!field || !value) continue;
    hasFacet = true;
    filters[field].push(value);
  }

  const facetCount = FACET_ROW_META.reduce((sum, row) => sum + filters[row.key].length, 0);
  return {
    presentation: hasDisplay || hasFacet || untagged || Boolean(deviceId),
    deviceId,
    play: display.seconds != null,
    untagged: untagged && facetCount === 0,
    filters,
    display: hasDisplay ? display : null,
  };
}
